<template>
  <div class="mrz-list">
    <div
      v-for="fieldName in MRZ_FIELDS"
      :key="fieldName"
      :class="['mrz-item', { 'mrz-item-edit': isDocumentEditEnabled }]"
    >
      <ui-field-input
        v-if="isDocumentEditEnabled"
        class="mrz-value"
        :value="fieldValues[fieldName]"
        @input="$emit('field-change', { fieldName, value: $event })"
        :disabled="actionInProgress || documentUpdating"
        :id="`field-${fieldName}`"
        type="text"
        bottom-margin="small"
      />
      <ui-field
        v-else-if="isMrzLineNotEmpty(fieldName)"
        class="mrz-value"
        bottom-margin="small"
      >
        {{ fieldValues[fieldName] }}
      </ui-field>
      <div v-if="isSymbolCountVisible(fieldName)" class="mrz-symbol-count">
        {{ mrzLinesCount[fieldName] }}
      </div>
    </div>
  </div>
</template>
<script>
import { MRZ_FIELDS } from "../../constants/mrz";

export default {
  props: {
    isDocumentEditEnabled: { type: Boolean, default: false },
    fieldValues: { type: Object, default: null },
    actionInProgress: { type: Boolean, default: false },
    documentUpdating: { type: Boolean, default: false },
    mrzLinesCount: { type: Object, default: null }
  },

  emits: ["field-change"],

  data() {
    return {
      MRZ_FIELDS
    };
  },

  methods: {
    isMrzLineNotEmpty(fieldName) {
      return this.mrzLinesCount[fieldName] > 0;
    },

    isSymbolCountVisible(fieldName) {
      return (
        this.isDocumentEditEnabled ||
        (!this.isDocumentEditEnabled && this.isMrzLineNotEmpty(fieldName))
      );
    }
  }
};
</script>
<style scoped lang="scss">
.mrz-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.mrz-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.mrz-item-edit {
  align-items: center;

  ::v-deep input {
    font-family: var(--mrz-font-family);
    font-weight: 400;
    letter-spacing: 0.0875rem;
  }
}

.mrz-value {
  width: 90%;
  font-family: var(--mrz-font-family);
  font-weight: 400;
  letter-spacing: 0.0875rem;
}

.mrz-symbol-count {
  margin-left: 1rem;
}
</style>
